import { cn } from '@/lib/utils/cn'

interface LogoProps {
  className?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl'
  variant?: 'default' | 'light'
}

export default function Logo({
  className,
  size = 'md',
  variant = 'default',
}: LogoProps) {
  const sizes = {
    sm: 'w-32',     // 128px - for compact spaces
    md: 'w-40',     // 160px - sidebar
    lg: 'w-48',     // 192px - header/footer
    xl: 'w-56',     // 224px - login/signup pages
    '2xl': 'w-72',  // 288px - landing hero
  }

  // For now, use the same logo for both variants
  // The logo works on both light and dark backgrounds
  const logoSrc = '/images/logo.png'

  return (
    <img
      src={logoSrc}
      alt="AsiliFlow"
      className={cn(
        sizes[size],
        'h-auto',
        variant === 'light' && 'brightness-0 invert', // Make logo white for dark backgrounds
        className
      )}
    />
  )
}
